import { Change } from '@ritabygglov/core';
import { IPendingChangeDrainer } from './IPendingChangeDrainer';
import { IPendingChangeStore } from './IPendingChangeStore';

export class ThrottledPendingChangeDrainer implements IPendingChangeDrainer {
  private active = false;
  private intervalTimer?: NodeJS.Timeout;

  constructor(
    private readonly batchSpacingMs: number = 150,
    private readonly retryIntervalMs: number = 3000
  ) {}

  start(
    store: IPendingChangeStore,
    sendFn: (batchId: string, changes: Change[]) => void
  ): void {
    this.stop();
    this.active = true;

    const pending = store.loadAll();

    [...pending.entries()].map(([batchId, changes], i) =>
      setTimeout(() => {
        if (!this.active) return;
        sendFn(batchId, changes);
      }, i * this.batchSpacingMs)
    );

    this.intervalTimer = setInterval(() => {
      const remaining = store.loadAll();
      if (remaining.size === 0) return;
      [...remaining.entries()].map(([batchId, changes]) =>
        sendFn(batchId, changes)
      );
    }, this.retryIntervalMs);
  }

  stop(): void {
    this.active = false;
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
      this.intervalTimer = undefined;
    }
  }
}
